import React from 'react'
import { reducer, initialState } from './reducer'

export const CostSearchContext = React.createContext({
  costSearchCriteriaState: initialState,
  costSearchCriteriaDispatch: () => null,
})

export const CostSearchProvider = ({ children }) => {
  const [costSearchCriteriaState, costSearchCriteriaDispatch] =
    React.useReducer(reducer, initialState)

  return (
    <CostSearchContext.Provider
      value={[costSearchCriteriaState, costSearchCriteriaDispatch]}
    >
      {children}
    </CostSearchContext.Provider>
  )
}
